import './AvatarGroup.css';
export var additionalAvatarWrapperCSS = '_129un530-3-5-0';
export var avatarGroupItemWrapperCSS = '_129un531-3-5-0';